module.exports = __webpack_public_path__ + "assets/img/noticeBg.4f35a076.png";